import React, {useEffect, useState} from "react";
import CustomerAccountOverview from "./CustomerAccountOverview";
import {ExclusiveSaleBanner} from "./ExclusiveSaleBanner";
import * as ReactDOM from "react-dom";
import NewsletterView from "./newsletter/NewsletterView";
import window from "../../lib/WindowExtended";

export const CustomerAccount: React.FC<{element: HTMLElement | null}> = ({element}) => {
  const initialState = new URLSearchParams(window.location.search).get("view") as CAView | null;
  const [view, setView] = useState<CAView | null>(initialState);

  const setViewNull = (e: PopStateEvent) => {
    const popStateView = e.state as {view?: string | null} | null;
    if (!popStateView?.view) {
      setView(null);
    }
  };

  useEffect(() => {
    if (element) {
      window.addEventListener("popstate", setViewNull);
    }

    return () => {
      window.removeEventListener("popstate", setViewNull);
    };
  }, []);

  useEffect(() => {
    if (element) {
      window.scrollTo(0, 0);
    }
  }, [view]);

  if (element === null) {
    return null;
  }

  const openView = (evt: React.MouseEvent<HTMLAnchorElement>, viewToOpen: CAView) => {
    evt.preventDefault();
    updateUrl(viewToOpen);
    setView(viewToOpen);
  };

  const updateUrl = (viewToOpen: CAView | null) => {
    const {origin, pathname, search, hash} = window.location;
    const usp = new URLSearchParams(search);
    if (viewToOpen) {
      usp.set("view", viewToOpen);
    } else {
      usp.delete("view");
    }
    window.history.pushState(
      {...window.history.state, view: viewToOpen},
      viewToOpen?.toString() ?? "",
      origin + pathname + (usp.toString() ? "?" + usp.toString() : "") + hash,
    );
  };

  const spinner = element.getElementsByClassName("swiper-lazy-preloader")[0];
  if (spinner) {
    element.removeChild(spinner);
  }

  return ReactDOM.createPortal(
    <React.Fragment>
      {view === null && <ExclusiveSaleBanner element={element} />}
      {view === null && <CustomerAccountOverview element={element} openView={openView} />}
      {view === CAView.Subscriptions && <NewsletterView />}
    </React.Fragment>,
    element,
  );
};

export enum CAView {
  Orders = "orders",
  Backs = "backs",
  Ratings = "ratings",
  CustomerData = "customer_data",
  CustomerAddress = "customer_address",
  Subscriptions = "subscriptions",
  ConnoxPlus = "connox_plus",
  CustomerDelete = "customer_delete",
  CustomerLogOut = "customer_logOut",
}
